(function () {
  'use strict';

  if (window.BigsmallSearchPredictiveAdapterLoaded) return;
  window.BigsmallSearchPredictiveAdapterLoaded = true;

  var FINDER_PATH = '/pages/ai-gift-finder';
  var instanceCount = 0;

  var LABELS = {
    brief: 'Get AI gift recommendations for this requirement',
    few_results: 'Not finding it? Get AI gift recommendations',
    no_results: 'No exact match? Get AI gift recommendations'
  };

  function finder() {
    return window.BigsmallAiFinder || null;
  }

  function finderUrl(query) {
    var api = finder();
    if (api) return api.finderUrl(query, 'predictive_dropdown');
    var value = String(query || '').trim();
    return value ? FINDER_PATH + '?q=' + encodeURIComponent(value) : FINDER_PATH;
  }

  // The AI action is only worth showing for a sentence-like brief, or when the
  // dropdown found no or very few matches. Otherwise it just gets in the way.
  function aiReason(term, total) {
    var api = finder();
    if (!api || !term) return '';
    if (api.looksLikeBrief(term)) return 'brief';
    if (total <= api.FEW_RESULTS_MAX) return total === 0 ? 'no_results' : 'few_results';
    return '';
  }

  function getInput(predictive) {
    return predictive && predictive.querySelector('input[type="search"]');
  }

  function getTerm(predictive) {
    var input = getInput(predictive);
    return input ? input.value.trim() : '';
  }

  function ensureAiAction(root, predictive, searchButton, term, reason, total) {
    var holder = root.querySelector('.bs-ai-predictive-action');

    if (!term || !reason) {
      if (holder) holder.hidden = true;
      return;
    }

    if (!holder) {
      holder = document.createElement('div');
      holder.className = 'bs-ai-predictive-action';

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'predictive-search__item';
      button.id = 'predictive-search-option-ai-' + (++instanceCount);
      button.setAttribute('role', 'option');
      button.setAttribute('aria-selected', 'false');
      button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.8l1.6 4.9 4.9 1.6-4.9 1.6-1.6 4.9-1.6-4.9-4.9-1.6 4.9-1.6L12 2.8Z"></path><path d="M18.4 14.8l.9 2.6 2.6.9-2.6.9-.9 2.6-.9-2.6-2.6-.9 2.6-.9.9-2.6Z"></path></svg><span></span>';
      button.addEventListener('click', function () {
        var api = finder();
        var currentTerm = getTerm(predictive);
        if (api) api.trackClick('predictive_dropdown', holder.dataset.reason || 'unknown', currentTerm, Number(holder.dataset.total || 0));
        window.location.assign(finderUrl(currentTerm));
      });

      holder.appendChild(button);
      if (searchButton && searchButton.parentNode === root) {
        root.insertBefore(holder, searchButton);
      } else if (searchButton && searchButton.parentNode) {
        searchButton.parentNode.insertBefore(holder, searchButton);
      } else {
        root.appendChild(holder);
      }
    }

    holder.dataset.reason = reason;
    holder.dataset.total = String(total);
    var label = holder.querySelector('button span');
    if (label) label.textContent = LABELS[reason];
    holder.hidden = false;

    var api = finder();
    if (api) api.trackView('predictive_dropdown', reason, term, total);
  }

  function decorate(predictive) {
    if (!predictive || !predictive.isConnected) return;
    var root = predictive.querySelector('[data-predictive-search]');
    if (!root) return;

    var queryHeading = root.querySelector('#predictive-search-queries');
    if (queryHeading) queryHeading.textContent = 'Suggested searches';

    ['#predictive-search-pages-desktop', '#predictive-search-pages-mobile'].forEach(function (selector) {
      var heading = root.querySelector(selector);
      if (heading) heading.textContent = 'Pages & guides';
    });

    root.querySelectorAll('.predictive-search__item-vendor').forEach(function (vendor) {
      vendor.hidden = true;
    });

    var term = getTerm(predictive);
    var searchFor = root.querySelector('[data-predictive-search-search-for-text]');
    var searchButton = searchFor && searchFor.closest('.predictive-search__search-for-button');
    if (searchFor && term) searchFor.textContent = 'View all results for “' + term + '”';

    var totalNode = root.querySelector('[data-total-results]');
    var total = Number(totalNode && totalNode.dataset ? totalNode.dataset.totalResults : 0) || 0;
    var empty = root.querySelector('.bigsmall-predictive-empty');

    if (total === 0 && term && searchButton) {
      if (!empty) {
        empty = document.createElement('div');
        empty.className = 'bigsmall-predictive-empty';
        empty.innerHTML = '<strong>No exact match yet</strong><span>Try a broader product name, category or gifting requirement.</span>';
        searchButton.parentNode.insertBefore(empty, searchButton);
      }
    } else if (empty) {
      empty.remove();
    }

    // Only judge "few results" once real results are in the dropdown, so a
    // half-loaded dropdown never counts as an empty one.
    var hasResults = !!totalNode;
    var reason = hasResults ? aiReason(term, total) : (finder() && finder().looksLikeBrief(term) ? 'brief' : '');
    ensureAiAction(root, predictive, searchButton, term, reason, total);
  }

  function init(predictive) {
    if (!predictive || predictive.dataset.bsSearchAdapterBound === 'true') return;
    predictive.dataset.bsSearchAdapterBound = 'true';

    var root = predictive.querySelector('[data-predictive-search]');
    if (!root) return;

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        decorate(predictive);
      });
    }

    var observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true });

    var input = getInput(predictive);
    if (input) input.addEventListener('input', schedule, { passive: true });

    decorate(predictive);
  }

  function scan(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    if (root.matches && root.matches('predictive-search')) init(root);
    root.querySelectorAll('predictive-search').forEach(init);
  }

  function boot() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target || document);
  });
})();
